import { MutableRefObject, useRef } from "react";
import { useReactToPrint } from "react-to-print";

interface IPrintWebPageProps {
  printRef: MutableRefObject<undefined>;
  documentTitle: string;
  pageStyle: string;
}

export const usePrintWebPage = ({
  printRef,
  documentTitle,
  pageStyle,
}: IPrintWebPageProps) => {
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle,
    pageStyle,
  });

  return { handlePrint };
};
